<script lang="ts">
</script>

<div class="mobile">
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="315.4"
		viewBox="0 0 315.4 61.5"
		overflow="visible">
		<rect x="0" y="21" width="39.5" height="39.5" rx="5" ry="5" />
		<text x={6} y={51}>W</text>
		<rect x={39.5 + 6.4} y="21" width="39.5" height="39.5" rx="5" ry="5" />
		<text x={58.5} y={51}>E</text>
		<rect x={91.8} y="22" width="39.5" height="39.5" rx="5" ry="5" />
		<text x={106} y={51}>L</text>
		<rect x={131.8 + 6.4} y="22" width="39.5" height="39.5" rx="5" ry="5" />
		<text x={148} y={51}>C</text>
		<ellipse id="shadow" cx={203.08} cy={39 + 13 + 10} rx={15} ry={3} />
		<animate
			xlink:href="#shadow"
			attributeName="rx"
			from="10"
			to="1"
			dur="2.5s"
			values="10; 3; 1; 10"
			keyTimes="0; 0.5; 0.65; 1"
			repeatCount="indefinite"
			fill="freeze"
			id="s" />
		<animate
			xlink:href="#shadow"
			attributeName="ry"
			from="3"
			to="1"
			dur="2.5s"
			values="3; 0.2; 0.05; 3"
			keyTimes="0; 0.5; 0.65; 1"
			repeatCount="indefinite"
			fill="freeze"
			id="s" />
		<rect
			id="O"
			x={177.7 + 6.4}
			y="12"
			width="39.5"
			height="39.5"
			rx="5"
			ry="5" />
		<animate
			xlink:href="#O"
			attributeName="y"
			from="12"
			to="0"
			dur="2.5s"
			values="12; 7; 0; 7; 12"
			keyTimes="0; 0.25; 0.5; 0.75; 1"
			repeatCount="indefinite"
			fill="freeze"
			id="circ-anim" />
		<circle id="white-o" r="8.05" cx={203.85 + 1.75} cy={12 + 19.5 + 1.65} />
		<animate
			xlink:href="#white-o"
			attributeName="cy"
			from="33.15"
			to="21.15"
			dur="2.5s"
			values="33.15; 28.15; 21.15; 28.15; 33.15"
			keyTimes="0; 0.25; 0.5; 0.75; 1"
			repeatCount="indefinite"
			fill="freeze"
			id="white-o" />
		<circle id="blue-o" r="8.05" cx={203.85 - 0.75} cy={12 + 19.5 - 0.849999} />
		<animate
			xlink:href="#blue-o"
			attributeName="cy"
			from="30.650001"
			to="18.650001"
			dur="2.5s"
			values="30.650001; 25.65001; 18.650001; 25.65001; 30.650001"
			keyTimes="0; 0.25; 0.5; 0.75; 1"
			repeatCount="indefinite"
			fill="freeze"
			id="blue-o" />
		<rect x={223.6 + 6.4} y="22" width="39.5" height="39.5" rx="5" ry="5" />
		<text x={237.5} y={51}>M</text>
		<rect x={269.5 + 6.4} y="22" width="39.5" height="39.5" rx="5" ry="5" />
		<text x={288} y={51}>E</text>
	</svg>
</div>

<style lang="scss">
	.mobile {
		width: 315.4px;
		height: 61px;

		ellipse {
			fill: rgba(0, 0, 0, 0.153);
		}

		rect {
			fill: var(--signature-blue);
			&:not(#O) {
				filter: drop-shadow(0px 3px 3px rgba(0, 0, 0, 0.721));
			}
			&#O {
				fill: #2d2d31;
				animation: infinite shadow 2s;
			}
		}
		text {
			fill: white;
			font: 700 26px normal;
			font-family: poppins;
		}

		circle {
			fill: var(--signature-blue);

			&#white-o {
				fill: transparent;
				stroke: white;
				stroke-width: 1;
			}
		}
	}

	@keyframes shadow {
		0% {
			filter: drop-shadow(0px 3px 3px rgba(0, 0, 0, 0.44));
		}

		50% {
			filter: drop-shadow(0px 3px 3px rgba(0, 0, 0, 0.139));
		}
		65% {
			filter: drop-shadow(0px 3px 3px rgba(0, 0, 0, 0.139));
		}

		100% {
			filter: drop-shadow(0px 3px 3px rgba(0, 0, 0, 0.44));
		}
	}

</style>
